import { Box, Button, Text } from "@radix-ui/themes";
import { GoogleOAuthProvider, GoogleLogin, useGoogleLogin, UseGoogleLoginOptionsAuthCodeFlow } from "@react-oauth/google";
import jwt from "jsonwebtoken";
import { useTranslations } from "next-intl";
import { fetchHost, fetchUtil } from "@/util/fetchutil";
import { getApiHostname } from "@/util/paramutil";
import { Debug } from "@/util/debug";
// import { GoogleAuth } from "@codetrix-studio/capacitor-google-auth";
import { Capacitor } from "@capacitor/core";
import { GoogleLoginOptions, SocialLogin } from "@capgo/capacitor-social-login";

import Icon from "@/components/common/icon/icon";
import { useContext, useEffect } from "react";
import { AlertContext } from "@/components/context/alertContext";
import { AlertProps } from "../layoutType";
import { loginFailed } from "./signin";
import { alertLoading } from "../list/defaultType";
// import dynamic from "next/dynamic";
// const Icon = dynamic(() => import("@/components/common/icon/icon"), { ssr: false });

export default function GoogleLoginButton({ loginFn }: { loginFn: Function }) {
  const ta = useTranslations("alert");
  // const a: UseGoogleLoginOptionsAuthCodeFlow = {};
  // const ux_mode = "redirect";//"popup"
  const ux_mode = "popup";
  const url = getApiHostname() + "/api/sign/callback/google";
  const alertContext = useContext(AlertContext);
  const alert_p = alertContext.setProp ?? ((prop: AlertProps) => {});
  useEffect(() => {
    if (Capacitor.getPlatform() !== "web") {
      SocialLogin.initialize({
        google: {
          webClientId: process.env.NEXT_PUBLIC_GOOGLE_CLIENT_ID ?? "",
        },
        // apple: {
        //   iOS용 Apple 설정
        //   clientId: "YOUR_APPLE_CLIENT_ID",
        // },
      });
    }
  }, []);

  const googleLogin = useGoogleLogin({
    scope: "email profile",
    ux_mode: ux_mode,
    redirect_uri: url,
    // hosted_domain: "coffeein.site",
    select_account: true,
    onSuccess: async (data: any) => {
      Debug("useGoogleLogin : " + data);
      Debug(data);

      setTimeout(() => {
        alert_p(alertLoading);
      }, 50);

      fetchUtil(
        url,
        {
          mode: "cors",
          method: "POST",
          headers: { "Content-type": "application/json" },
          credentials: "include",
          body: JSON.stringify({
            code: data.code,
            ux_mode: ux_mode,
          }),
        },
        undefined,
        (data: any) => {
          Debug(data);
          loginFn(data);
          try {
            if (data?.result?.idToken != null) {
              Debug(jwt.decode(data.result.idToken));
            } else {
              Debug("idToken is null");
            }
          } catch (e) {
            Debug("idToken is null");
          }
        },
        (error: any) => {
          loginFailed(ta, alert_p);
        },
      );
      //fetchUtil()
      // axios
      //   .post("http://localhost:4000/auth/google/callback", { code })
      //   .then(({ data }) => {
      //     console.log(data);
      //   });
    },
    onError: (errorResponse) => {
      loginFailed(ta, alert_p);
      console.error(errorResponse);
    },
    flow: "auth-code",
  });
  const appLogin = () => {
    const platform = Capacitor.getPlatform();
    const options: GoogleLoginOptions = { scopes: ["profile", "email"] };
    if (platform === "ios") {
      options.forceRefreshToken = true;
    }
    SocialLogin.login({ provider: "google", options: options }).then((logdata) => {
      const result: any = logdata ? logdata.result : null;
      if (result !== null && result.idToken) {
        // const tokens = ;
        alert_p(alertLoading);

        Debug("사용자 정보:", logdata); //Debug
        Debug("idToken:", jwt.decode(result.idToken)); //Debug
        // console.log("tokens:", tokens); //Debug
        fetchUtil(
          url,
          {
            mode: "cors",
            method: "POST",
            headers: { "Content-type": "application/json" },
            credentials: "include",
            body: JSON.stringify({
              platform: platform,
              idToken: result.idToken,
              accessToken: result.accessToken.token,
              refreshToken: result.accessToken.refreshToken,
            }),
          },
          undefined,
          (data: any) => {
            Debug(data);
            loginFn(data);
            try {
              if (data?.result?.idToken != null) {
                Debug(jwt.decode(data.result.idToken));
              } else {
                Debug("idToken is null");
              }
            } catch (e) {
              Debug("idToken is null");
            }
          },
          (error: any) => {
            loginFailed(ta, alert_p);
          },
        );
      } else {
        loginFailed(ta, alert_p);
      }
    });
  };
  //const a : GoogleLoginProps;
  //a.context
  return (
    <>
      <Button
        variant="solid"
        type="button"
        color="indigo"
        size="3"
        className="p-3 cursor-pointer mb-4 mx-[13px]"
        onClick={Capacitor.getPlatform() === "web" ? googleLogin : appLogin}
      >
        <Icon iconType="phosphor" iconName="GoogleLogo" weight="bold" />
        <Text weight="bold">{ta("signin_google")}</Text>
      </Button>
      {/* <Box id="googleLogin">
         <GoogleLogin
           width="480px"
           containerProps={{
             style: { width: "100%", margin: "0px 0px 0px 1px" },
           }}
           
           logo_alignment="left"
           onSuccess={(res) => {
             alert(res);
             Debug(jwt.decode(res.credential));
             console.log(res);
           }}
         />
       </Box> */}
    </>
  );
}
